import { FC } from "react";
import "./PdfViewer.css";

interface PdfViewerProps {
  /** Public path to the PDF file (e.g. /assets/manifesto.pdf) */
  pdfPath: string;
  title?: string;
}

const PdfViewer: FC<PdfViewerProps> = ({ pdfPath, title = "PDF" }) => {
  return (
    <div className="pdf-viewer-wrapper">
      <iframe
        title={title}
        src={`${pdfPath}#toolbar=1`}
        className="pdf-viewer-iframe"
      />
    </div>
  );
};

export default PdfViewer;
